import useParseURL from 'hooks/useParseURL';
import {validate as isValidUUID} from 'uuid';
import * as I from 'interfaces';
import {Navigate} from 'react-router-dom';

export const PlanRoute = ({children}) => {
  const {planId} = useParseURL();

  if (!planId || !isValidUUID(planId)) {
    return <Navigate to={I.URLPathname.root} replace />;
  }

  return children;
};
